import React from 'react';
import { Avatar, Box, IconButton, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import placeholderImage from '../assets/product-placeholder.png';

interface DialogHeaderProps {
	title: string;
	imgUrl?: string;
    imgPlaceholder?: boolean;
	onClose: () => void;
}

export const DialogHeader = ({ title, imgUrl, imgPlaceholder, onClose }: DialogHeaderProps) => {
	const theme = useTheme();
	const isMdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
	return (
		<Box p={theme.spacing(1, 2, 1, 3)} gap={2} display='flex' alignItems='center'>
			{isMdUp && (imgUrl || imgPlaceholder) && <Avatar src={imgUrl} variant='square' sx={{width: 80, height: 80, borderRadius: 2}} >
				<img src={placeholderImage} alt={title} width={80} height={80} />
			</Avatar>}
			<Typography variant='h6' flexGrow={1}>{title}</Typography>
			<IconButton onClick={onClose} sx={(theme) => ({
				color: theme.palette.grey[500],
			})}>
				<CloseIcon />
			</IconButton>
		</Box>
	);
};
